import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BaseLayout from './BaseLayout';
import UserTable from '../UserTable';
import LoginAttemptTable from '../LoginAttemptTable';
import Storage from '../../Storage';
import { browserHistory, Link } from 'react-router';

class UserPage extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = {
      selectedIndex: this.calcTabIndexFromUrlPath(),
    };
    this.onBrowserHistoryChange = this.onBrowserHistoryChange.bind(this);
  }

  onBrowserHistoryChange() {
    let { location } = this.props;
    // when browser back button is pressed
    if (location.action === 'POP' && !this.unmounted) {
      this.handleSelect(this.calcTabIndexFromUrlPath());
    }
  }

  componentDidMount() {
    this.handleSelect(this.calcTabIndexFromUrlPath());
    this.unsubscribeBrowserHistoryChange = browserHistory.listen(this.onBrowserHistoryChange);
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.unsubscribeBrowserHistoryChange) {
      this.unsubscribeBrowserHistoryChange();
    }
  }

  calcTabIndexFromUrlPath() {
    let pathname = this.props.location.pathname;
    let index = 0;
    switch (pathname) {
      case '/user/list':
        index = 0;
        break;
      case '/user/failed-login-attempts':
        index = 1;
        break;
      case '/user/successful-login-attempts':
        index = 2;
        break;
    }
    // console.log('calc', pathname, index);
    return index;
  }

  handleSelect(index, last) {
    // console.log('handleSelect', index, last);
    this.setState({ selectedIndex: index }, () => {
      switch (index) {
        case 0:
          Storage.setTabPathname('user', '/user/all');
          break;
        case 1:
          Storage.setTabPathname('user', '/user/failed-login-attempts');
          break;
        case 2:
          Storage.setTabPathname('user', '/user/successful-login-attempts');
          break;
      }
      browserHistory.push(Storage.getTabPathname('user'));
    });
  }

  render() {
    let userList = this.props.userList || [];
    let loginAttemptList = this.props.loginAttemptList || [];
    let failedLoginAttemptList = loginAttemptList.filter((attempt) => (attempt.isSuccess = 'N'));
    let successfulLoginAttemptList = loginAttemptList.filter(
      (attempt) => (attempt.isSuccess = 'Y')
    );

    return (
      <BaseLayout {...this.props} selectedTabName='user'>
        <Tabs onSelect={this.handleSelect.bind(this)} selectedIndex={this.state.selectedIndex}>
          <TabList style={{ textAlign: 'center' }}>
            <Tab>
              <i className='fa fa-fw fa-user' />
              Users
            </Tab>
            <Tab>
              <i className='fa fa-fw fa-user-times' />
              Failed Login Attempts
            </Tab>
            <Tab>
              <i className='fa fa-fw fa-user-md' />
              Successful Login Attempts
            </Tab>
          </TabList>
          <TabPanel>
            <UserTable
              {...this.props}
              tableTitle='Users'
              tableHeight={BaseLayout.calcTableHeight(userList)}
              userList={userList}
            />
          </TabPanel>
          <TabPanel>
            <LoginAttemptTable
              {...this.props}
              tableTitle='Failed Login Attempts'
              tableHeight={BaseLayout.calcTableHeight(failedLoginAttemptList)}
              loginAttemptList={failedLoginAttemptList}
              success={false}
              limit={500}
            />
          </TabPanel>
          <TabPanel>
            <LoginAttemptTable
              {...this.props}
              tableTitle='Successful Login Attempts'
              tableHeight={BaseLayout.calcTableHeight(successfulLoginAttemptList)}
              loginAttemptList={successfulLoginAttemptList}
              success={true}
              limit={500}
            />
          </TabPanel>
        </Tabs>
      </BaseLayout>
    );
  }
}

export default UserPage;



// WEBPACK FOOTER //
// ./src/components/pages/UserPage.js